<template>
    <b-form class="main-form" @submit.stop.prevent="onSubmit" @reset.stop.prevent="onReset" v-if="show">

        <h2 class="text-center">Editar dados</h2>

        <b-form-group label="País:">
            <b-form-select
                v-model="form.country"
                :options="countries"
                value-field="iso3"
                text-field="nome"
                required
            ></b-form-select>
        </b-form-group>

        <b-form-group label="Nome Completo:">
            <b-form-input
                v-model="form.fullname"
                type="text"
                required
                placeholder="Digite o nome completo"
            ></b-form-input>
        </b-form-group>

        <b-form-group label="Atuação">
            <b-form-checkbox-group v-model="form.jobs">
                <b-form-checkbox value="Profissional"
                    >Profissional</b-form-checkbox
                >
                <b-form-checkbox value="Estudante"
                    >Estudante</b-form-checkbox
                >
                <b-form-checkbox value="Professor"
                    >Professor</b-form-checkbox
                >
                <b-form-checkbox value="Pesquisador"
                    >Pesquisador</b-form-checkbox
                >
            </b-form-checkbox-group>
        </b-form-group>

        <b-form-group label="Instituição (Se houver):">
            <vue-bootstrap-typeahead 
                ref="typeahead"
                v-model="form.institution"
                :data="institutions"
                placeholder="Digite o nome da instituição"
            />
        </b-form-group>

        <b-form-group label="E-mail:">
            <b-form-input
                v-model="form.email"
                type="email"
                required
                placeholder="Digite o email"
            ></b-form-input>
        </b-form-group>

        <div class="text-center">
            <b-button type="submit" variant="primary">Salvar</b-button>
            &nbsp;&nbsp;&nbsp;
            <b-button type="reset" variant="danger">Limpar</b-button>
        </div>
    </b-form>
</template>

<script>
import countries from "./../assets/paises.json";
import Institution from "./../models/Institution";
import { getProfileAction, changeProfileAction, getUser, modifyUser } from './../configs/services';
import Bus from "./../configs/bus";
import Swal from 'sweetalert2';

export default {
    name: 'EditProfile',
    props: ['id'],
    data() {
        return {
            form: {
                email: "",
                fullname: "",
                country: "Brasil",
                jobs: [],
                institution: ""
            },
            countries: countries.map(x => x.nome),
            institutions: [],
            show: true
        }
    },
    async created(){
        let items = await Institution.get();
        
        this.institutions = items.map(x => x.name);
        
        console.log(this.$props);

        if(!this.$props.id){
            this.form = await getProfileAction();
            this.$refs.typeahead.inputValue = this.form.institution;
        }else{
            this.form = await getUser(this.$props.id);
            this.$refs.typeahead.inputValue = this.form.institution;
            //console.log('KK')
        }

        console.log(this.form)
    },
    methods: {
        onSubmit(evt) {
            Bus.$emit("toggle", null);
            
            let action = null;
            
            if(!this.$props.id){
                action = changeProfileAction(this.form);
            }else{
                action = modifyUser(this.$props.id, this.form);
            }

            action
            .then((data) => {
                Swal.fire("Sucesso!", "Perfil editado com sucesso", "success");
            })
            .catch(this.errorHandler)
            .then(() => {
                Bus.$emit("toggle", null);
            })
        },

        onReset(evt) {
            // Reset our form values
            this.form = {
                email: "",
                fullname: "",
                country: "BRA",
                jobs: [],
                institution: ""
            };

            // Trick to reset/clear native browser form validation state
            this.show = false

            this.$nextTick(() => {
                this.show = true
            })
        }
    }
}
</script>

<style>
.main-form {
    background-color: #ddcecb;
}
</style>